import styled from 'styled-components';
import {
  COLOR,
  FONT_SIZE,
  LINE_HEIGHT,
  FONT_WEIGHT
} from '@latitude/core/utils/constants';

const Table = styled.table`
  width: 100%;
  text-align: left;
  border-collapse: separate;
  border-spacing: 0;
  color: ${COLOR.GREY75};
  font-size: ${FONT_SIZE.NORMAL};
  font-weight: ${FONT_WEIGHT.LIGHT};
  line-height: ${LINE_HEIGHT.STANDARD};

  tr {
    :first-child td {
      padding-top: 0;
    }
    td {
      padding: 16px 4px;
      :first-child {
        padding-left: 0;
        width: 45%;
      }
      :last-child {
        padding-right: 0;
      }
      strong {
        font-weight: 500;
      }
      a {
        text-decoration: underline;
      }
    }
  }
`;

const Row = styled.tr`
  ${({ mergeDown }) =>
    mergeDown &&
    `
    td {
      border-bottom: none;
      padding-bottom: 5px !important;
    }
    + tr td {
      padding-top: 5px !important;
    }
  `}

  ${({ fontWeight }) => fontWeight && `font-weight: ${fontWeight};`}

  ${({ footNote }) =>
    footNote &&
    `
    font-size: 12px;
    font-weight: 300;
    text-align: center;

    td:first-child {
      border-bottom: 0;
      padding-bottom: 0;
    }
  `}
`;

const Cell = styled.td`
  vertical-align: top;
  border-bottom: solid 1px ${COLOR.GREY10};
`;

export { Table, Row, Cell };
